import { createAction } from 'redux-actions'

const ns = 'featuresAdmin/'

// Fetch feature flags for a company
export const getCompanyFeatureFlags = createAction(`${ns}GET_COMPANY_FEATURE_FLAGS`)
export const getCompanyFeatureFlagsSuccess = createAction(`${ns}GET_COMPANY_FEATURE_FLAGS_SUCCESS`)
export const getCompanyFeatureFlagsFail = createAction(`${ns}GET_COMPANY_FEATURE_FLAGS_FAIL`)

// Update feature flags for a company
export const updateCompanyFeatureFlags = createAction(`${ns}UPDATE_COMPANY_FEATURE_FLAGS`)
export const updateCompanyFeatureFlagsSuccess = createAction(`${ns}UPDATE_COMPANY_FEATURE_FLAGS_SUCCESS`)
export const updateCompanyFeatureFlagsFail = createAction(`${ns}UPDATE_COMPANY_FEATURE_FLAGS_FAIL`)
